import { createSlice } from '@reduxjs/toolkit';
import { blackboxUpload } from './thunks';

const initialState = {
  fileUploaderOpen: false,
  fileUploading: false,
};

const slice = createSlice({
  name: 'blackbox',
  initialState: initialState,
  reducers: {
    toggleBlackBoxFileUploader: (state, { payload }) => {
      state.fileUploaderOpen = payload;
    },
  },
  extraReducers: {
    [blackboxUpload.fulfilled]: state => {
      state.fileUploading = false;
    },
    [blackboxUpload.pending]: state => {
      state.fileUploading = true;
    },
    [blackboxUpload.rejected]: state => {
      state.fileUploading = false;
    },
  },
});

export const { toggleBlackBoxFileUploader } = slice.actions;

export default slice.reducer;
